import React, { useEffect } from 'react';
import { extend } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { CustomerContext, useThdCustomer } from '@thd-olt-functional/customer-information';
import { declareContexts } from '@thd-olt-component-react/hydrator';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ProjectSummary } from '@thd-olt-component-react/project-summary';
import { useNavigate, useLocation } from '@thd-olt-component-react/router';
import { BackToTop } from '@thd-olt-component-react/back-to-top';
import { CustomerAccountNavigation, useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { Typography, Badge } from '@one-thd/sui-atomic-components';
import { PROJECTS_CRUMB, UNAUTHORIZED_SVOCID_PROJECT_DETAILS } from '../../constants';
import { updateQueryParams } from '../../helpers';

export const Projects = () => {
  declareContexts([ExperienceContext, CustomerContext]);
  const navigate = useNavigate();
  const { search: querystring, pathname, state } = useLocation();
  const isUnauthorizedProjectDetails = state?.projectDetails?.error === UNAUTHORIZED_SVOCID_PROJECT_DETAILS;
  const path = `${pathname}${querystring}`;

  const { isB2BCustomer } = useThdCustomer();

  const urlParams = new URLSearchParams(querystring);
  const page = Number(urlParams.get('page')) || 1;
  const onPageChange = (pageNo) => {
    const updatePath = updateQueryParams(path, [
      {
        paramName: 'page',
        paramValue: pageNo
      }
    ]);
    navigate(updatePath);
  };

  const projectsCrumbs = useAccountCrumbs([
    PROJECTS_CRUMB
  ]).map((crumb) => {
    return {
      label: crumb.label,
      url: crumb.path || crumb.url,
    };
  });

  return (
    <div className="sui-max-w-screen-2xl sui-mx-auto sui-p-4">
      <div>
        <ErrorBoundary name="projects-landing-page-breadcrumbs">
          <Breadcrumbs staticCrumbs={projectsCrumbs} />
        </ErrorBoundary>
        <Typography variant="h1" weight="display">
          PROJECTS <Badge variant="regular" color="info">NEW</Badge>
        </Typography>
      </div>
      <div className="sui-grid sui-grid-cols-12 sui-gap-4">
        <div className="lg:sui-col-span-3 sui-col-span-12 lg:sui-pt-8">
          <ErrorBoundary name="projects-landing-page-left-hand-nav">
            <CustomerAccountNavigation />
          </ErrorBoundary>
        </div>
        <div className="sui-col-span-12 lg:sui-col-span-9">
          <ErrorBoundary name="projects-landing-page-projects-list">
            <ProjectSummary
              iconSize="regular"
              page={page}
              onPageChange={onPageChange}
              isValidCustomer={isB2BCustomer}
              isUnauthorizedProjectDetails={isUnauthorizedProjectDetails}
            />
          </ErrorBoundary>
        </div>
      </div>
      <ErrorBoundary name="projects-landing-page-back-to-top">
        <BackToTop />
      </ErrorBoundary>
    </div>
  );
};

Projects.displayName = 'ProjectsLandingPage';

Projects.dataModel = extend(
  ProjectSummary,
  Breadcrumbs,
  CustomerAccountNavigation
);

Projects.propTypes = {
};

Projects.defaultProps = {
};
